export const PROJECT_PORTFOLIO_SINGLE_NUMBER = {
	ACTUAL_REVENUE: 'actualRevenue',
	ACTUAL_COST: 'actualCost',
	ACTUAL_PROFIT: 'actualProfit',
	PLAN_REVENUE: 'plannedRevenue',
	PLAN_COST: 'plannedCost',
	PLAN_PROFIT: 'plannedProfit',
	REMAINING_REVENUE: 'remainingRevenue',
	REMAINING_COST: 'remainingCost',
	REMAINING_PROFIT: 'remainingProfit',
	FORECAST_REVENUE: 'forecastRevenue',
	FORECAST_COST: 'forecastCost',
	FORECAST_PROFIT: 'forecastProfit',
	INVOICED: 'invoiced',
	INVOICE_PAID: 'paid',
};

export const getSingleNumberLabel = (singleNumber, intl) => {
	switch (singleNumber) {
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.ACTUAL_REVENUE:
			return intl.formatMessage({id: 'project_budget.actual_revenue'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.ACTUAL_COST:
			return intl.formatMessage({id: 'common.actual_cost'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.ACTUAL_PROFIT:
			return intl.formatMessage({id: 'project_budget.actual_profit'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.PLAN_REVENUE:
			return intl.formatMessage({id: 'project_budget.plan_revenue'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.PLAN_COST:
			return intl.formatMessage({id: 'project_budget.plan_cost'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.PLAN_PROFIT:
			return intl.formatMessage({id: 'project_budget.plan_profit'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.REMAINING_REVENUE:
			return intl.formatMessage({id: 'project_budget.remaining_revenue'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.REMAINING_COST:
			return intl.formatMessage({id: 'project_budget.remaining_cost'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.REMAINING_PROFIT:
			return intl.formatMessage({id: 'project_budget.remaining_profit'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.FORECAST_REVENUE:
			return intl.formatMessage({id: 'project_budget.forecast_revenue'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.FORECAST_COST:
			return intl.formatMessage({id: 'project_budget.forecast_cost'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.FORECAST_PROFIT:
			return intl.formatMessage({id: 'project_budget.forecast_profit'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.INVOICED:
			return intl.formatMessage({id: 'common.invoiced'});
		case PROJECT_PORTFOLIO_SINGLE_NUMBER.INVOICE_PAID:
			return intl.formatMessage({id: 'project_budget.invoice_paid'});
	}
};
